import useMartyContext from 'hooks/useMartyContext';

const LowStockLabel = () => {
  const { testId } = useMartyContext();

  return (
    <p
      className="absolute bottom-0 left-0 bg-gray-50 p-1 text-[10px] leading-[14px] text-red-350 lg:text-xs"
      data-test-id={testId('lowStockLabel')}
      aria-label="Low stock"
    >
      Low Stock
    </p>
  );
};

export default LowStockLabel;
